import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { OAuthService } from 'angular-oauth2-oidc';
import { from } from 'rxjs';

import { tap } from 'rxjs/operators';

@Injectable()
export class HubConnectionManager {
  hubConnections: { [key: string]: signalR.HubConnection } = {};

  constructor(private authService: OAuthService) {}

  async connect(name: string, url: string, actions: On[]) {
    this.hubConnections[name] = new signalR.HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: async () => {
          return this.authService.getAccessToken();
        },
      })
      .configureLogging(signalR.LogLevel.Trace)
      .build();
    const promises: Promise<any>[] = [];
    for (const action of actions) {
      this.hubConnections[name].on(action.methodName, action.newMethod);

      promises.push(this.hubConnections[name].start());
    }

    await Promise.all(promises);

    return this.hubConnections[name];
  }

  stop(name: string) {
    return from(this.hubConnections[name]?.stop() ?? Promise.resolve()).pipe(
      tap(() => delete this.hubConnections[name]),
    );
  }

  stopAll() {
    const promises: Promise<any>[] = [];
    for (const connection of Object.values(this.hubConnections)) {
      promises.push(connection.stop());
    }

    return from(Promise.all(promises));
  }
}

export interface On {
  methodName: string;
  newMethod: (message: string) => void;
}
